module.exports = __webpack_public_path__ + "img/horizontal_3_7_pp12_3009.9acc3f1d.png";